import React from "react";
import { SlidersHorizontal } from "lucide-react";

const TaskListFilters = ({
    role = "admin",
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    viewFilter,
    setViewFilter,
    todayCount = 0,
    onAdvancedClick,
    onCompletedFilter,
}) => (
    <div className="flex flex-col gap-2">
        {role === "staff" && (
            <div className="grid grid-cols-2 gap-2">
                <button
                    type="button"
                    onClick={() => setViewFilter("today")}
                    className={`rounded-lg border px-3 py-2.5 text-sm font-semibold transition min-h-[44px] ${
                        viewFilter === "today"
                            ? "border-primary bg-primary-soft text-primary"
                            : "border-line bg-surface-2 text-ink-secondary hover:bg-surface-3"
                    }`}
                >
                    Due today
                    {todayCount > 0 && (
                        <span className="ml-1.5 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1 rounded-full bg-primary text-primary-contrast text-[11px]">
                            {todayCount}
                        </span>
                    )}
                </button>
                <button
                    type="button"
                    onClick={() => setViewFilter("all")}
                    className={`rounded-lg border px-3 py-2.5 text-sm font-semibold transition min-h-[44px] ${
                        viewFilter === "all"
                            ? "border-primary bg-primary-soft text-primary"
                            : "border-line bg-surface-2 text-ink-secondary hover:bg-surface-3"
                    }`}
                >
                    All tasks
                </button>
            </div>
        )}

        <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex flex-wrap gap-2">
                <select
                    value={statusFilter}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === "Completed") onCompletedFilter?.();
                        setStatusFilter(value);
                    }}
                    className="flex-1 min-w-[140px] border border-line rounded-lg px-3 py-2 text-xs bg-surface-2 text-ink focus:outline-none focus:ring-1 focus:ring-primary min-h-[44px] lg:min-h-0 lg:py-1.5"
                    aria-label="Filter by status"
                >
                    <option value="">All statuses</option>
                    <option value="active">Active</option>
                    <option value="Completed">Completed</option>
                </select>
                <select
                    value={priorityFilter}
                    onChange={(e) => setPriorityFilter(e.target.value)}
                    className="flex-1 min-w-[140px] border border-line rounded-lg px-3 py-2 text-xs bg-surface-2 text-ink focus:outline-none focus:ring-1 focus:ring-primary min-h-[44px] lg:min-h-0 lg:py-1.5"
                    aria-label="Filter by priority"
                >
                    <option value="">All priorities</option>
                    <option value="high">High</option>
                    <option value="medium">Medium</option>
                    <option value="low">Low</option>
                </select>
            </div>

            {role === "admin" && (
                <button
                    type="button"
                    onClick={onAdvancedClick}
                    className="hidden md:inline-flex items-center gap-1.5 text-ink-secondary hover:text-ink cursor-pointer text-xs font-medium transition min-h-[44px] lg:min-h-0 px-2 rounded-lg hover:bg-surface-2"
                >
                    <SlidersHorizontal size={14} />
                    Advanced options
                </button>
            )}
        </div>
    </div>
);

export default TaskListFilters;
